import { useState, useEffect } from "react";

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Industries", href: "#industries" },
  { label: "Trust & Security", href: "#enterprise-trust" },
  { label: "Careers", href: "#careers" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <nav className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#home");
            }}
            className="flex items-center gap-2.5 select-none"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-heading font-bold text-sm md:text-base">
                RS
              </span>
            </div>
            <span
              className={`font-heading font-bold text-lg md:text-xl tracking-tight transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              RedeemSoft
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className={`px-3.5 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                    : "text-background-200 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+17325488002"
              className={`flex items-center gap-1.5 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-background-200 hover:text-background-50"
              }`}
            >
              <i className="ri-phone-line" />
              <span>(732) 548-8002</span>
            </a>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("#contact");
              }}
              className="ml-2 px-5 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Schedule a Call
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled
                ? "text-foreground-950 hover:bg-background-100"
                : "text-background-50 hover:bg-white/10"
            }`}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileOpen}
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </nav>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-3 border-t border-background-200/70 space-y-2">
              <a
                href="tel:+17325488002"
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors"
              >
                <i className="ri-phone-line" />
                (732) 548-8002
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick("#contact");
                }}
                className="block w-full text-center px-5 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}